const MINUTE = 60
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

// Formats a duration in seconds for the lead time cards: days once it is at
// least a day, hours below that, minutes below an hour.
export const formatLeadTime = (seconds: number): string => {
  if (!Number.isFinite(seconds) || seconds < 0) {
    return '-'
  }
  if (seconds >= DAY) {
    return `${(seconds / DAY).toFixed(1)} d`
  }
  if (seconds >= HOUR) {
    return `${(seconds / HOUR).toFixed(1)} h`
  }
  return `${Math.round(seconds / MINUTE)} min`
}
